import { render, staticRenderFns } from "./TeamRosterSection.vue?vue&type=template&id=535a01b9&scoped=true&"
import script from "./TeamRosterSection.vue?vue&type=script&lang=js&"
export * from "./TeamRosterSection.vue?vue&type=script&lang=js&"
import style0 from "./TeamRosterSection.vue?vue&type=style&index=0&id=535a01b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535a01b9",
  null
  
)

export default component.exports